// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"be81af98","86":"20e94a71","443":"3f1496f8","459":"314d7d8a","926":"e0f6c30f"}[chunkId] + ".css";
};